/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    CREATE_CONTACT_ACCOUNT_POSITION,
    GET_CONTACT_ACCOUNT_POSITION,
    UPDATE_CONTACT_ACCOUNT_POSITION
} from "../../database/queries/contactAccountPositionQueries";
import {notify} from "../../utils/notify";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import usePersistentStore from "../../persistentStore";
import {useHistory, useParams} from "react-router-dom";
import Button from "@material-ui/core/Button";
import ChooseOrAddAccount from "../Common/chooseOrAddAccount";
import {simulateMouseClick, tellParentContentHeight, tellParentMessage} from "../../utils/utils";
import ReactResizeDetector from 'react-resize-detector';
import PageBar from "../Common/PageBar";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
    },
    formControlError: {
        'input': {
            '&::placeholder': {
                color: 'red'
            }
        },
        '& .MuiFormLabel-root': {
            color: 'red'
        },
        '& .MuiInput-underline:before': {
            borderColor: 'red'
        },
    },
    gridContainer: {
        // overflow: 'auto',
        // overflowY: 'scroll',
        // padding: 10,
        // border: '1px solid #d3d4d5'
    },
    typeField: {
        paddingRight: 20
    },
    statusField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    priorityField: {
        paddingLeft: 30,
        paddingRight: 30
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
    shrink: {
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
    }
}));

const INITIAL_CONTACT_ACCOUNT_POSITION = {
    contactAccountPositionId: null,
    contactId: null,
    accountId: null,
    location: '',
    title: '',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment('2999-12-31').format('YYYY-MM-DD'),
    current: true,
    lastConfirmedAt: moment().format('YYYY-MM-DD'),
    positionDescription: ''
};

const PopupContactAccountPositionEdit = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    let {accountId, contactAccountPositionId} = useParams();
    const [contactAccountPosition, setContactAccountPosition] = useState({
        ...INITIAL_CONTACT_ACCOUNT_POSITION,
        contactAccountPositionId: contactAccountPositionId,
        accountId: accountId !== 'new' && accountId !== 'existing' ? accountId : null,
        accountName: globalPersistentState.popupQueryObj ? globalPersistentState.popupQueryObj.selectionText : '',
        contactId: props.parentEditId
    });
    const [errors, setErrors] = useState({});
    const history = useHistory();

    const {loading: getContactAccountPositionLoading, error: getContactAccountPositionError, data: getContactAccountPositionData} = useQuery(GET_CONTACT_ACCOUNT_POSITION, {
        skip: !contactAccountPositionId || contactAccountPositionId === 'new',
        variables: {contactAccountPositionId: contactAccountPositionId},
    });

    const [updateContactAccountPosition, {error: updateContactAccountPositionError}] = useMutation(UPDATE_CONTACT_ACCOUNT_POSITION);
    const [createContactAccountPosition, {error: createContactAccountPositionError}] = useMutation(CREATE_CONTACT_ACCOUNT_POSITION);
    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    useEffect(() => {
        if (createContactAccountPositionError) notify('createContactAccountPositionError', 'error', createContactAccountPositionError.message);
        if (getContactAccountPositionError) notify('getContactAccountPositionError', 'error', getContactAccountPositionError.message);
        if (updateContactAccountPositionError) notify('updateContactAccountPositionError', 'error', updateContactAccountPositionError.message);
    }, [createContactAccountPositionError, getContactAccountPositionError, updateContactAccountPositionError]);

    useEffect(() => {
        if (getContactAccountPositionData && getContactAccountPositionData.contactAccountPosition) {
            let fetchedContactAccountPosition = {...getContactAccountPositionData.contactAccountPosition}
            setContactAccountPosition(fetchedContactAccountPosition);
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getContactAccountPositionData]);

    useEffect(() => {
    }, [contactAccountPosition]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    const contentCallback = useCallback(node => tellParentContentHeight(node, globalPersistentState.popupQueryObj), []);

    const onResize = (w, h) => {
        tellParentMessage({contentHeight: h}, globalPersistentState.popupQueryObj)
    };

    const callbackRef = useCallback(inputElement => {
        if (inputElement) {
            inputElement.focus();
            const acctNameFld = document.getElementById('choose-account-autocomplete');
            if (acctNameFld) simulateMouseClick(acctNameFld);
        }
    }, []);

    const changeContactAccountPosition = ((field, value) => {
        let updatedContactAccountPosition = {...contactAccountPosition}

        if (field === 'current') {
            updatedContactAccountPosition.current = !contactAccountPosition.current;
            if (updatedContactAccountPosition.current) {
                updatedContactAccountPosition.endDate = moment('2999-12-31').format('YYYY-MM-DD');
            } else {
                updatedContactAccountPosition.endDate = moment().format('YYYY-MM-DD');
            }
        } else {
            updatedContactAccountPosition[field] = value;
        }

        setContactAccountPosition(updatedContactAccountPosition);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    });

    const handleChange = (e) => {
        if (e.target) changeContactAccountPosition(e.target.name, e.target.value);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};

        if (!contactAccountPosition.accountId || contactAccountPosition.accountId.length === '') newError.accountId = 'Please select an existing account or create a new one.'

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getContactAccountPositionLoading) return <p>Loading ...</p>;

    return (
        <div ref={contentCallback}>
            <form className={classes.root}>
                {contactAccountPosition && (<>
                    <PageBar title={`Edit position ${props.editObj ? 'for ' + props.editObj.displayName : ''}`}/>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.leftField}>
                            <FormControl
                                className={errors.contactAccountPositionAccount ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <ChooseOrAddAccount
                                    ref={callbackRef}
                                    accountId={contactAccountPosition.accountId}
                                    accountName={contactAccountPosition.accountName}
                                    onChange={(chosen) => {
                                        changeContactAccountPosition('accountId', chosen.id);
                                    }}
                                />

                                <FormHelperText>
                                    {errors.accountId}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="location"
                                    name="location"
                                    label="Location"
                                    fullWidth
                                    size="small"
                                    value={contactAccountPosition.location}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} className={classes.titleField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="title"
                                    name="title"
                                    label="Title"
                                    fullWidth
                                    size="small"
                                    value={contactAccountPosition.title}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={8}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="positionDescription"
                                    name="positionDescription"
                                    label="Position description"
                                    fullWidth
                                    size="small"
                                    multiline
                                    rowsMax="3"
                                    value={contactAccountPosition.positionDescription}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.rightField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            id="current"
                                            name="current"
                                            checked={contactAccountPosition.current}
                                            onChange={handleChange}
                                            value={contactAccountPosition.current}
                                        />
                                    }
                                    label="Current?"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.leftField}>
                            <FormControl
                                className={errors.startAt ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="startDate"
                                    name="startDate"
                                    type="date"
                                    helpertext="Start date"
                                    onChange={handleChange}
                                    value={contactAccountPosition.startDate}
                                    required
                                    label="Start Date"
                                    fullWidth
                                    size="small"
                                />
                                <FormHelperText>
                                    {errors.startDate}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        {!contactAccountPosition.current && <Grid item xs={6} className={classes.rightField}>
                            <FormControl
                                className={errors.dueAt ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="endDate"
                                    name="endDate"
                                    type="date"
                                    helpertext="End date"
                                    onChange={handleChange}
                                    value={contactAccountPosition.endDate}
                                    required
                                    label="End Date"
                                    fullWidth
                                    size="small"
                                />
                                <FormHelperText>
                                    {errors.endDate}
                                </FormHelperText>
                            </FormControl>
                        </Grid>}
                    </Grid>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.leftField}>
                            <Button
                                id={"btn-cancel"}
                                fullWidth={true}
                                variant="contained"
                                onClick={() => {
                                    globalPersistentActions.clearPopupQueryObjSelectionText();
                                    console.log('## SVR popupContactAccountPosition ## changing history', '/popup/contact/' + props.parentEditId + '/positions');
                                    history.push('/popup/contact/' + props.parentEditId + '/positions');
                                    props.parentRefresh();
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <Button
                                id={"btn-save"}
                                fullWidth={true}
                                variant="contained"
                                color="primary"
                                disabled={contactAccountPosition.accountId !== null}
                                onClick={() => {
                                    if (validateForm()) {
                                        if (contactAccountPosition.contactAccountPositionId && contactAccountPosition.contactAccountPositionId !== 'new') {
                                            updateContactAccountPosition({
                                                variables: {
                                                    changedContactAccountPosition: {
                                                        contactAccountPositionId: contactAccountPosition.contactAccountPositionId,
                                                        contactId: props.parentEditId,
                                                        accountId: contactAccountPosition.accountId,
                                                        location: contactAccountPosition.location,
                                                        title: contactAccountPosition.title,
                                                        startDate: moment(contactAccountPosition.startDate).format(),
                                                        endDate: moment(contactAccountPosition.endDate).format(),
                                                        current: contactAccountPosition.current,
                                                        lastConfirmedAt: moment(contactAccountPosition.lastConfirmedAt).format(),
                                                        positionDescription: contactAccountPosition.positionDescription
                                                    }
                                                }
                                            }).then(async (updateResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'contactAccountPosition',
                                                                parentId: contactAccountPosition.contactAccountPositionId,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                globalPersistentActions.clearPopupQueryObjSelectionText();
                                                notify('createContactAccountPosition', 'info', 'Contact account position updated', null, null, globalPersistentState.popupQueryObj);
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupContactAccountPosition ## changing history', '/popup/contact/' + props.parentEditId + '/positions');
                                                history.push('/popup/contact/' + props.parentEditId + '/positions');
                                                props.parentRefresh();
                                            }).catch(e => {
                                                console.trace(e);
                                                notify('updateContactAccountPosition', 'error', 'Problem updating contact account position', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        } else {
                                            createContactAccountPosition({
                                                variables: {
                                                    newContactAccountPosition: {
                                                        contactId: props.parentEditId,
                                                        accountId: contactAccountPosition.accountId,
                                                        location: contactAccountPosition.location,
                                                        title: contactAccountPosition.title,
                                                        startDate: moment(contactAccountPosition.startDate).format(),
                                                        endDate: moment(contactAccountPosition.endDate).format(),
                                                        current: contactAccountPosition.current,
                                                        lastConfirmedAt: moment(contactAccountPosition.lastConfirmedAt).format(),
                                                        positionDescription: contactAccountPosition.positionDescription
                                                    }
                                                }
                                            }).then(async (createResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'contactAccountPosition',
                                                                parentId: createResult.data.createContactAccountPosition.id,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                globalPersistentActions.clearPopupQueryObjSelectionText();
                                                notify('createContactAccountPosition', 'info', 'Contact account position created', null, null, globalPersistentState.popupQueryObj);
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupContactAccountPosition ## changing history', '/popup/contact/' + props.parentEditId + '/positions');
                                                history.push('/popup/contact/' + props.parentEditId + '/positions');
                                                props.parentRefresh();
                                            }).catch(e => {
                                                notify('updateContactAccountPosition', 'error', 'Problem creating contact account position', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        }
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </>)}
            </form>
            <ReactResizeDetector handleWidth handleHeight onResize={onResize}/>
        </div>
    )
};

export default PopupContactAccountPositionEdit
